import React from 'react';
import PropTypes from 'prop-types';
import { OrderSummary } from '../OrderSummary';
import { StyledCheckoutInformation } from './styles.js';

export const CheckoutInformation = ({
  plans,
  orderSummary,
  recurringOrders,
  nextDeliveryDate,
  buttonRef,
  disabled = false,
  isSubmitting = false,
  isValidating = false,
  showAddons,
  period,
  showPromoCode,
  applyPromoCode,
  removePromoCode,
  isDefaultPromoCode,
  currentOfferCode,
}) => {
  return (
    <StyledCheckoutInformation>
      <OrderSummary
        {...orderSummary}
        plans={plans}
        nextDeliveryDate={nextDeliveryDate}
        buttonRef={buttonRef}
        disabled={disabled}
        isSubmitting={isSubmitting}
        isValidating={isValidating}
        recurringOrders={recurringOrders}
        period={period}
        showAddons={showAddons}
        showPromoCode={showPromoCode}
        applyPromoCode={applyPromoCode}
        removePromoCode={removePromoCode}
        isDefaultPromoCode={isDefaultPromoCode}
        currentOfferCode={currentOfferCode}
      />
    </StyledCheckoutInformation>
  );
};

CheckoutInformation.displayName = 'CheckoutInformation';

CheckoutInformation.propTypes = {
  plans: PropTypes.arrayOf(PropTypes.object).isRequired,
  orderSummary: PropTypes.object.isRequired,
  recurringOrders: PropTypes.shape({
    foodPacksText: PropTypes.string.isRequired,
  }).isRequired,
  nextDeliveryDate: PropTypes.string,
  recurringDeliveryDate: PropTypes.string,
  buttonRef: PropTypes.any,
  disabled: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  isValidating: PropTypes.bool,
  showAddons: PropTypes.bool.isRequired,
  period: PropTypes.string.isRequired,
  showPromoCode: PropTypes.bool.isRequired,
  applyPromoCode: PropTypes.func.isRequired,
  removePromoCode: PropTypes.func.isRequired,
  isDefaultPromoCode: PropTypes.bool.isRequired,
  currentOfferCode: PropTypes.string.isRequired,
};
